import { assign } from 'lodash-es'
import { useLocale } from 'next-intl'
import { renderToString } from 'react-dom/server'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useUnmount } from 'react-use'
import SvgRotate from '@img/rotate.svg'
import Script from 'next/script'

function addRotateButton(player) {
  // eslint-disable-next-line no-underscore-dangle
  const playerEl = player.el_
  const siblingEl = playerEl.querySelector('.vjs-custom-control-spacer')
  const rotateButton = document.createElement('button')
  const rotateWrap = document.createElement('div')
  rotateWrap.className = 'vjs-video-rotate vjs-menu-button vjs-menu-button-popup vjs-control vjs-button'
  rotateButton.className = 'vjs-menu-button vjs-menu-button-popup vjs-button'
  rotateButton.setAttribute('type', 'button')
  rotateButton.innerHTML = renderToString(
    <SvgRotate style={{ display: 'block', margin: '0 auto', width: 16 }} viewBox="0 0 22 22" />
  )
  let rotate = 0
  let isPortrait = false
  rotateButton.onclick = () => {
    rotate++
    if (rotate === 4) rotate = 0
    const videoEl = playerEl.querySelector('.vjs-tech')
    videoEl.style.transform = `rotate(${rotate * 90}deg)`

    const w = videoEl.offsetWidth
    const h = videoEl.offsetHeight
    videoEl.style.width = isPortrait ? '100%' : `${h}px`
    videoEl.style.height = isPortrait ? '100%' : `${w}px`
    videoEl.style.position = isPortrait ? 'static' : 'relative'
    videoEl.style.left = isPortrait ? 'auto' : `${-(h - w) / 2}px`
    videoEl.style.top = isPortrait ? 'auto' : `${(h - w) / 2}px`
    isPortrait = !isPortrait
  }
  rotateWrap.appendChild(rotateButton)
  siblingEl.parentNode.insertBefore(rotateWrap, siblingEl.nextSibling)
}

export default function useTcPlayer({ containerId, sources, options, rotateButton = true }) {
  const [initialized, setInitialized] = useState(false)
  const playerRef = useRef(null)
  const local = useLocale()

  const initPlayer = useCallback(() => {
    if (initialized) return
    setInitialized(true)

    playerRef.current = new window.TCPlayer(
      containerId,
      assign(
        {
          sources,
          language: local === 'zh' ? 'zh-CN' : 'en',
          licenseUrl: process.env.NEXT_PUBLIC_LICENSE_URL
        },
        options
      )
    )

    // 添加一个旋转按钮
    if (rotateButton) {
      playerRef.current.one('loadstart', () => {
        addRotateButton(playerRef.current)
      })
    }

    playerRef.current.on('webrtcevent', (err) => {
      console.error('webrtcevent', err)
    })
  }, [containerId, sources, options, initialized, setInitialized, playerRef, local, rotateButton])

  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.src(sources)
    }
  }, [sources, playerRef])

  useUnmount(() => {
    if (playerRef.current) {
      playerRef.current.dispose()
    }
  })

  return {
    initPlayer
  }
}

export function TcPlayerLayout({
  onReady
}) {
  return (
    <>
      <Script
        src="https://web.sdk.qcloud.com/player/tcplayer/release/v5.0.1/tcplayer.v5.0.1.min.js"
        strategy="afterInteractive"
        onReady={onReady}
      />
      <link
        rel="stylesheet"
        href="https://web.sdk.qcloud.com/player/tcplayer/release/v5.0.1/tcplayer.min.css"
      />
    </>
  )
}
